<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-checkbox label="Harga Tanpa Kebijakan" v-model="filter.displayDefaultAreaPrice" />
        <base-input
          v-model="filter.search"
          :shadow="false"
          placeholder="Cari Kode"
          debounce
          @native-input="loadOrders"
          type="search"
        />
        <base-select
          fit
          :shadow="false"
          :options="[
            { key: 'all', label: 'Status', value: null },
            { key: 'invalid', label: 'Draft', value: false },
            { key: 'valid', label: 'Valid', value: true },
          ]"
          v-model="filter.is_valid_for_packing"
          @change="loadOrders"
        />
        <base-button :to="{ name: 'restock.tambah' }"
          >Tambah Restock</base-button
        >
      </div>
      <div>
        <datatable
          :columns="columns"
          :data="orders.data"
          :scroll-x="false"
          :total="orders.meta.page.total"
          :perPage="orders.meta.page.perPage"
          :currentPage="orders.meta.page.currentPage"
          :meta="orders.meta"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="(order) in orders.data"
              :key="order.id"
              :class="[
                classes.tr,
                getRowClass(order),
                'cursor-pointer bg-white hover:bg-green-100',
              ]"
              @click="
                onClickRow(
                  getSingleIncluded(orders, order.relationships.order.data.id)
                )
              "
            >
              <td :class="[classes.td]">
                <p>
                  <span class="font-bold text-gray-900">{{
                    order.attributes.origin_code
                  }}</span>
                  / <span>{{ order.attributes.destination_code }}</span>
                </p>
                <span class="text-xs text-gray-400">{{
                  order.attributes.createdAt | formatDate
                }}</span>
              </td>
              <td :class="classes.td">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.origin_office_code
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes[filter.displayDefaultAreaPrice ? 'default_area_price' : 'grand_total_price'] | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.payment_amount | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.grand_total_pv | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.total_bonus_value | toCurrency
                }}
              </td>
              <td :class="[classes.td, 'text-center']" :title="getSingleIncluded(orders, order.relationships.order.data.id).attributes.latest_cancel_description">
                <base-badge
                  :color="
                    order.attributes.order_status === 'Draft'
                      ? 'yellow'
                      : 'green'
                  "
                  >{{ order.attributes.order_status }}</base-badge
                >
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </div>
    <view-order-modal
      :visible="viewOrderModal.visible"
      :order-id="viewOrderModal.orderId"
      edit-route-name="restock.edit"
      label="Restock Stockist Center"
      with-bonus
      :order-detail-columns="['code', 'qty', 'price', 'total_price', 'packed_qty', 'unpacked_qty']"
      :display-default-area-price="filter.displayDefaultAreaPrice"
      @close="viewOrderModal.visible = false"
      @validated="onValidated"
      @deleted="onDeleted"
    />
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import ViewOrderModal from '@/components/order/view-order-modal.vue';
import { mapGetters } from 'vuex';
import BaseCheckbox from '../../../../components/base/BaseCheckbox.vue';

export default {
  mixins: [requestMixin],
  components: { ViewOrderModal, BaseCheckbox },
  data() {
    return {
      filter: {
        is_valid_for_packing: null,
        search: null,
        displayDefaultAreaPrice: false
      },
      orders: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      loading: false,
      viewOrderModal: {
        visible: false,
        orderId: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    columns() {
      return [
        { id: 'code', name: 'No Restock' },
        { id: 'office_code', name: 'Kode Kantor' },
        {
          id: 'grand_total_price',
          name: 'Total Harga',
          theadClass: 'text-right',
        },
        { id: 'payment_amount', name: 'Pembayaran', theadClass: 'text-right' },
        { id: 'point', name: 'PV', theadClass: 'text-right' },
        { id: 'bonus', name: 'BV', theadClass: 'text-right' },
        {
          id: 'order_status',
          name: 'Status Faktur',
          theadClass: 'text-center',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    getRowClass(simpleOrder) {
      const order = this.getSingleIncluded(
        this.orders,
        simpleOrder.relationships['order'].data.id
      )

      if (!order.attributes.default_area_price) {
        return 'bg-white'
      }

      if (order.attributes.default_area_price === order.attributes.grand_total_price) {
        return 'bg-white'
      }

      return 'bg-yellow-50'
    },
    async loadOrders(params = {}) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/orders', {
        params: {
          'page[size]': 5,
          'filter[destination_warehouse_id]': this.me.current_warehouse,
          include: 'order',
          'filter[search]': this.filter.search,
          ...(this.filter.is_valid_for_packing === null
            ? {}
            : this.filter.is_valid_for_packing === true
            ? { 'filter[not-order_status]': 'Draft' }
            : { 'filter[order_status]': 'Draft' }),
          'fields[simple-orders]':
            'order_id,order,origin_code,destination_code,createdAt,order_status',
          'fields[orders]':
            'default_area_price,origin_office_code,is_valid_for_packing,grand_total_price,payment_amount,grand_total_pv,total_bonus_value,latest_cancel_description',
          'filter[is_transfer_promo]': false,
          'filter[is_transfer_promo_regular]': false,
          'filter[is_group_shipment]': false,
          ...params,
        },
      });

      if (!error) {
        this.orders = res;
      }

      this.loading = false;
    },
    onClickRow(order) {
      this.viewOrderModal.orderId = order.id;
      this.viewOrderModal.visible = true;
    },
    onPageChanged(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
    onValidated() {
      this.viewOrderModal.visible = false;
      this.loadOrders();
    },
    onDeleted() {
      this.viewOrderModal.visible = false;
      this.loadOrders();
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
